import { Pressable, styled, SxProp } from 'dripsy';
import { ActivityIndicator } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';

import React from 'react';

import { ButtonVariant, useButton } from './useButton.hook';
import { Icon, SVGIconList } from '../icons/Icon';
import { TextView } from '@/design-system/components/typography/UniTypography';
import { Space } from '../Space';

export interface UniButtonProps {
  onPress: () => void;
  sx?: SxProp;
  labelSx?: SxProp;
  label?: string;
  size?: 'small' | 'medium' | 'large' | 'default';
  variant?: ButtonVariant;
  prefixIcon?: SVGIconList;
  suffixIcon?: SVGIconList;
  loading?: boolean;
  disabled?: boolean;
  wrapperSx?: SxProp;
}

export interface ButtonViewProps {
  pressed: boolean;
  size: 'small' | 'medium' | 'large' | 'default';
  variant: ButtonVariant;
  sx?: SxProp;
  labelSx?: SxProp;
  label?: string;
  prefixIcon?: SVGIconList;
  suffixIcon?: SVGIconList;
  loading?: boolean;
  disabled?: boolean;
}

const Gradient = styled(LinearGradient, {
  themeKey: 'buttons',
  defaultVariant: 'base'
})({});

export const UniButton: React.FC<UniButtonProps> = (props) => {
  const {
    label,
    sx,
    labelSx,
    onPress,
    size = 'medium',
    variant = ButtonVariant.primary,
    loading,
    disabled,
    prefixIcon,
    suffixIcon,
    wrapperSx
  } = props;
  return (
    <Pressable onPress={disabled || loading ? () => {} : onPress} sx={wrapperSx}>
      {({ pressed }) => {
        return (
          <ButtonView
            label={label}
            sx={sx}
            pressed={pressed}
            size={size}
            variant={variant}
            loading={!!loading}
            disabled={!!disabled}
            prefixIcon={prefixIcon}
            suffixIcon={suffixIcon}
            labelSx={labelSx}
          />
        );
      }}
    </Pressable>
  );
};

const ButtonView: React.FC<ButtonViewProps> = (props) => {
  const { label, labelSx, sx, size, pressed, variant, loading, disabled, prefixIcon, suffixIcon } = props;
  const { buttonStyle, backgroundGradients, labelStyle, iconColor } = useButton({
    size,
    pressed,
    variant,
    loading,
    disabled
  });

  return (
    <Gradient colors={backgroundGradients} sx={{ ...buttonStyle, ...sx }} start={{ x: 0.5, y: 0.0 }} end={{ x: 1, y: 0.0 }}>
      {loading && (
        <>
          <ActivityIndicator size="small" color={iconColor} />
          <Space width="$2" />
        </>
      )}
      {!loading && prefixIcon && (
        <>
          <Icon name={prefixIcon || 'search'} color={iconColor} />
          <Space width="$2" />
        </>
      )}
      {label && (
        <TextView bold sx={{ ...labelStyle, ...labelSx }}>
          {label}
        </TextView>
      )}
      {suffixIcon && (
        <>
          <Space width="$2" />
          <Icon name={suffixIcon || 'search'} color={iconColor} />
        </>
      )}
    </Gradient>
  );
};
